import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen p-6 max-w-4xl mx-auto">
      <Button 
        variant="ghost" 
        onClick={() => navigate(-1)}
        className="mb-6"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Voltar
      </Button>

      <h1 className="text-3xl font-bold mb-6">Política de Privacidade</h1>
      
      <div className="space-y-6 text-muted-foreground">
        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">1. Informações que Coletamos</h2>
          <p>Coletamos as seguintes informações:</p>
          
          <div className="mt-3 space-y-3">
            <div>
              <h3 className="font-semibold text-foreground">Dados de Conta:</h3>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>Email e senha (criptografada)</li>
                <li>Nome e avatar</li>
                <li>Data de nascimento e peso (opcional)</li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-foreground">Dados de Atividade:</h3>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>Rotas de corrida (GPS)</li>
                <li>Distância, duração, ritmo, calorias</li>
                <li>Frequência cardíaca (se disponível)</li>
                <li>Emoções pré/pós corrida</li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-foreground">Dados Sociais:</h3>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>Posts no feed da comunidade</li>
                <li>Mensagens com mentores</li>
                <li>Check-ins em eventos</li>
                <li>Interações (reações, comentários)</li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-foreground">Dados de Localização:</h3>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>Localização em tempo real durante corridas</li>
                <li>Localização aproximada para grupos locais</li>
                <li>Localização para funcionalidade SOS</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">2. Como Usamos Seus Dados</h2>
          <p>Utilizamos suas informações para:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Fornecer e melhorar nossos serviços</li>
            <li>Rastrear seu progresso e desempenho</li>
            <li>Conectar você com mentores e comunidade local</li>
            <li>Personalizar recomendações de treino</li>
            <li>Detectar RunMatch (corredores próximos)</li>
            <li>Processar alertas SOS de segurança</li>
            <li>Enviar notificações relevantes</li>
            <li>Análises e melhorias do aplicativo</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">3. Compartilhamento de Dados</h2>
          <p className="mb-2"><strong>NÃO vendemos seus dados pessoais.</strong></p>
          <p>Compartilhamos dados apenas quando:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li><strong>Você autoriza:</strong> Posts públicos, perfil visível, eventos</li>
            <li><strong>Serviços necessários:</strong> Provedores de infraestrutura (Supabase, hosting)</li>
            <li><strong>Emergências:</strong> Alertas SOS compartilhados com contatos de emergência</li>
            <li><strong>Requisitos legais:</strong> Quando exigido por lei</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">4. Controle de Privacidade</h2>
          <p>Você tem controle sobre:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li><strong>Visibilidade do Feed:</strong> Escolha se suas corridas aparecem publicamente</li>
            <li><strong>Métricas Visíveis:</strong> Oculte distância/ritmo em posts públicos</li>
            <li><strong>RunMatch:</strong> Ative/desative detecção de corredores próximos</li>
            <li><strong>Localização:</strong> Conceda ou revogue permissão de GPS</li>
            <li><strong>Notificações:</strong> Gerencie preferências de comunicação</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">5. Segurança dos Dados</h2>
          <p>Implementamos medidas de segurança incluindo:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Criptografia SSL/TLS em todas as comunicações</li>
            <li>Senhas armazenadas com hash bcrypt</li>
            <li>Autenticação de dois fatores (quando disponível)</li>
            <li>Backups regulares e redundância</li>
            <li>Políticas de acesso restrito aos dados</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">6. Retenção de Dados</h2>
          <p>Mantemos seus dados enquanto:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Sua conta estiver ativa</li>
            <li>Necessário para cumprir obrigações legais</li>
            <li>Para resolver disputas</li>
          </ul>
          <p className="mt-2">
            Ao excluir sua conta, seus dados pessoais são removidos dentro de 30 dias, exceto 
            quando exigido por lei.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">7. Cookies e Tecnologias</h2>
          <p>
            Usamos cookies e tecnologias similares para:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Manter você logado</li>
            <li>Lembrar preferências</li>
            <li>Análise de uso do aplicativo</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">8. Direitos do Usuário (LGPD)</h2>
          <p>Você tem direito a:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incorretos</li>
            <li>Solicitar exclusão de dados</li>
            <li>Exportar seus dados</li>
            <li>Revogar consentimentos</li>
            <li>Opor-se ao processamento</li>
          </ul>
          <p className="mt-2">
            Para exercer esses direitos, acesse as configurações do app ou contate: privacidade@youbetterrun.app
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">9. Menores de Idade</h2>
          <p>
            O YBR é destinado a usuários com 16 anos ou mais. Se você tem entre 16-18 anos, 
            precisa de autorização dos pais/responsáveis para usar o serviço.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">10. Alterações na Política</h2>
          <p>
            Podemos atualizar esta política periodicamente. Mudanças significativas serão notificadas 
            via email ou notificação no app. Recomendamos revisar esta página regularmente.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">11. Contato</h2>
          <p>
            Dúvidas sobre privacidade? Entre em contato:
          </p>
          <ul className="list-none mt-2 space-y-1">
            <li>Email: privacidade@youbetterrun.app</li>
            <li>Telefone: (11) 99999-9999</li>
            <li>Endereço: São Paulo, SP, Brasil</li>
          </ul>
        </section>

        <div className="pt-6 border-t text-sm">
          <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          <p className="mt-2">
            Esta política está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018)
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
